import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RecordingService {
  private pauseMonitorSub = new BehaviorSubject<boolean | undefined>(undefined);
  public set pauseMonitor(value: boolean | undefined) {
    this.pauseMonitorSub.next(value);
  }
  pauseMonitor$ = this.pauseMonitorSub.asObservable();

  constructor() {}
}
